import { createRingTransport, Logger, LogLevel } from '@littlebird/logger';

import { isDev, isProd } from '@/env';

import { sentryTransport } from './transports/sentry';

const level = isDev ? LogLevel.Debug : LogLevel.Info;

const SYNC_LOG_RING_CAPACITY = 300;
export const sdkLogRing = createRingTransport(SYNC_LOG_RING_CAPACITY);

const webLogger = Logger.create({
  level,
  context: 'web-logger',
  transports: isProd ? [sentryTransport] : [],
  enableConsoleTransport: isDev,
});

const sdkLogger = Logger.create({
  level,
  context: 'sdk-logger',
  transports: [sdkLogRing.transport, ...(isProd ? [sentryTransport] : [])],
  enableConsoleTransport: isDev,
});

const authClientLogger = Logger.create({
  level,
  context: 'auth-client-logger',
  transports: isProd ? [sentryTransport] : [],
  enableConsoleTransport: isDev,
});

export { webLogger as logger, sdkLogger, authClientLogger };
